__turbopack_context__.v({
  "Button": "EventsCards-module___DSGgW__Button",
  "ButtonCards": "EventsCards-module___DSGgW__ButtonCards",
  "CardsContainer": "EventsCards-module___DSGgW__CardsContainer",
  "CardsContentF": "EventsCards-module___DSGgW__CardsContentF",
  "CardsImage": "EventsCards-module___DSGgW__CardsImage",
  "CategorySlider": "EventsCards-module___DSGgW__CategorySlider",
  "DateSlider": "EventsCards-module___DSGgW__DateSlider",
  "Title": "EventsCards-module___DSGgW__Title",
  "TitleSections": "EventsCards-module___DSGgW__TitleSections",
  "TitleSlider": "EventsCards-module___DSGgW__TitleSlider",
});
